module.exports = __webpack_public_path__ + "static/media/asset_4.d6a789e0.jpg";